/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Feedback } from '../../models/feedback';
import { UpdateFeedbackRequest } from '../../models/update-feedback-request';

export interface UpdateFeedback$Params {
  id: string;
      body: UpdateFeedbackRequest
}

export function updateFeedback(http: HttpClient, rootUrl: string, params: UpdateFeedback$Params, context?: HttpContext): Observable<StrictHttpResponse<Feedback>> {
  const rb = new RequestBuilder(rootUrl, updateFeedback.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple"});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Feedback>;
    })
  );
}

updateFeedback.PATH = '/v0/feedbacks/{id}';
